import { render, staticRenderFns } from "./control3YufaReport.vue?vue&type=template&id=a4cc7aba&scoped=true&"
import script from "./control3YufaReport.vue?vue&type=script&lang=js&"
export * from "./control3YufaReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cc7aba",
  null
  
)

export default component.exports